// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_SUPPLIESLIST = 'GET_SUPPLIESLIST';
export const GET_SUPPLIES_LOOKUP = 'GET_SUPPLIES_LOOKUP';
export const CREATE_SUPPLIESLIST = 'CREATE_SUPPLIESLIST';
export const UPDATE_SUPPLIESLIST = 'UPDATE_SUPPLIESLIST';
export const DELETE_SUPPLIESLIST = 'DELETE_SUPPLIESLIST';
